"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BubbleType=void 0;var t;(function(e){e.Category="category",e.Shipment="shipment",e.Store="store"})(t||(exports.BubbleType=t={}));
//# sourceMappingURL=BubbleType.js.map
